module.exports = __webpack_public_path__ + "static/media/jupiter.deb471f9.png";